export const environment = {
    production: true,
    baseURL: "https://api-ver2.getprepped.in"
    // baseURL: "https://getprepped-product-backend.onrender.com"
    // baseURL: "http://localhost:6001",
  };